<script setup lang="ts">
import { AkIcon } from '@ankorstore/design-system';
</script>

<template>
  <span class="frozen-badge">
    <AkIcon symbol="snowflake" />
  </span>
</template>

<style lang="scss">
.frozen-badge {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border-color: theme('colors.frozen.300');
  border-width: 1px;
  border-style: solid;
  background-color: theme('colors.frozen.100');
  aspect-ratio: 1;
  i {
    color: theme('colors.frozen.900');
    font-size: 1rem;
  }
}
</style>
